module.exports = __webpack_public_path__ + "static/media/GuatemalaCity.2a8caba2.jpg";